import NivTableOfContents from "../../../../src/client/niv_acuteboekje/ui/NivTableOfContents.js";
import NivTableOfContentsProduction from "../../../../src/client/niv_acuteboekje/ui/NivTableOfContentsProduction.js";
import NivTableOfContentsNewlyAdded from "../../../../src/client/niv_acuteboekje/ui/NivTableOfContentsNewlyAdded.js";
import * as React from 'react';
export default {
  NivTableOfContents,
  NivTableOfContentsProduction,
  NivTableOfContentsNewlyAdded,
  React
};